var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { inject } from 'mobx-react';
import { GDPRBannerExplictOptIn } from '../../global-navigation/common/banner';
var BannerComponent = /** @class */function (_super) {
  __extends(BannerComponent, _super);
  function BannerComponent() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  BannerComponent.prototype.isBannerType = function (type) {
    return this.props && this.props.globalComponentsContext && this.props.globalComponentsContext.header && this.props.globalComponentsContext.header.banner && this.props.globalComponentsContext.header.banner.type && this.props.globalComponentsContext.header.banner.type === type;
  };
  BannerComponent.prototype.render = function () {
    if (!this.isBannerType('gdpr')) {
      return null;
    }
    return React.createElement(GDPRBannerExplictOptIn, {
      globalComponentsContext: this.props.globalComponentsContext
    });
  };
  BannerComponent = __decorate([inject('globalComponentsContext')], BannerComponent);
  return BannerComponent;
}(React.PureComponent);
export { BannerComponent };
export var Banner = BannerComponent;